/**
 * Checks if a key value is a simple printable character suitable for display.
 * Returns false for:
 * - Dead keys (accent composing keys like Option+E → ´)
 * - Multi-character key names (like "Enter", "Shift", "Dead")
 * - Non-ASCII characters produced by Option combinations
 * - Control characters
 */
export const isSimplePrintableKey = (key: string): boolean => {
  // Must be a single character
  if (key.length !== 1) {
    return false;
  }

  const charCode = key.charCodeAt(0);

  // Printable ASCII range: 0x20 (space) to 0x7E (~)
  // This excludes non-ASCII characters that Option+key produces on macOS
  return charCode >= 0x20 && charCode <= 0x7e;
};
